import { envVariables } from '@fabric-ui/utils';

export const isExportMode = () => envVariables.VITE_ENV === 'export';

export const getExporterWorkflowMetadata = () => {
  const workflowId = localStorage.getItem('export_workflowId');
  const runId = localStorage.getItem('export_runId');
  return runId || workflowId ? { workflowId, runId, name: 'ExportDashboardWorkflow' } : {};
};
